import { useEffect } from "react";
import { Button, Typography } from "antd";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { triggerUnifiedResize, useIsUnifiedMode } from "@/shared/utils";
import { ObjectFormRadio } from "..";
import { FormType } from "../../types/form-type";
import { ObjectFormExaminationsBlock } from "./object-form-examinations-block";

export function ObjectFormExaminations() {
  const { register, control, getValues, setValue } = useFormContext<FormType>();
  const isUnifiedMode = useIsUnifiedMode();

  const { fields, append, remove } = useFieldArray<FormType>({
    control,
    name: "examinations.documentationExaminations",
    shouldUnregister: true,
  });

  const required = useWatch<FormType>({
    control,
    name: "examinations.required",
  });

  useEffect(() => {
    if (required && fields?.length < 1) {
      append({});
    }
  }, [required, fields.length, append]);

  useEffect(() => {
    register("deletedExaminations");
  }, [register]);

  const handleAddExamination = () => {
    append({});
    if (isUnifiedMode) {
      triggerUnifiedResize();
    }
  };

  const removeLocal = (index:number) => {
    const id = getValues(
      `examinations.documentationExaminations.${index}.documentationExaminationId` as const,
    ) as string | undefined;
    if (id) {
      const current = (getValues("deletedExaminations") as Set<string> | undefined) || new Set<string>();
      const next = new Set(current);
      next.add(id);
      setValue("deletedExaminations", next);
    }
    remove(index);
  };


  return (
    <div className="form-section form-body">
      <Typography.Title
        level={5}
        style={{
          margin: 0,
        }}
      >
        Сведения о положительном заключении экспертизы проектной документации
      </Typography.Title>
      <ObjectFormRadio
        name="examinations.required"
        control={control}
        radioOptions={[
          { title: "Требуется", value: true },
          { title: "Не требуется", value: false },
        ]}
      />
      {required && (
        <>
          <div>
            Заполняется если в соответствии со ст.49 Градостроительного кодекса
            РФ проводится экспертиза проектной документации
          </div>
          {fields.map((field, index) => (
            <ObjectFormExaminationsBlock
              remove={removeLocal}
              availableToRemove={!required || fields.length > 1}
              key={field.id}
              index={index}
            />
          ))}
          <Button
            type="dashed"
            style={{
              width: "fit-content",
              backgroundColor: "#EAEEF8",
            }}
            onClick={handleAddExamination}
          >
            Добавить еще заключение экспертизы
          </Button>
        </>
      )}
    </div>
  );
}
